module.exports = __webpack_public_path__ + "img/lyLogo.24180b55.jpg";